module.exports = __webpack_public_path__ + "img/im_hero_bg_mob@2x.a2c61513.jpg";